import { render, staticRenderFns } from "./DaySelector.vue?vue&type=template&id=50aa4472&scoped=true&"
import script from "./DaySelector.vue?vue&type=script&lang=js&"
export * from "./DaySelector.vue?vue&type=script&lang=js&"
import style0 from "./DaySelector.vue?vue&type=style&index=0&id=50aa4472&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa4472",
  null
  
)

export default component.exports